import React from "react";
import ContainerTemplate from "../../components/template/Container";
import PanelAreasView from "./PanelAreasView";
import * as ROUTES from "../../router/Routes";

const AreasInfoPage = () => {
  return (
    <ContainerTemplate active={ROUTES.areasInfo} routes={[ROUTES.areas]}>
      <PanelAreasView />
    </ContainerTemplate>
  );
};

export default AreasInfoPage;
